import React from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'

const Modal = ({modal, setModal, setOption}) => {
  return (
    <div className="absolute flex bg-black/40 w-screen top-0 left-0 h-screen z-50">
        <div className="flex justify-center items-center w-full">
            <div className="bg-white flex flex-col p-4 pt-6 px-14 text-center">
                <div className="relative right-0 w-[100%] bg-red-50" onClick={()=>setModal(!modal)}>
                    <AiFillCloseCircle className="absolute -right-12 -top-4 hover:scale-105 hover:cursor-pointer transiton-all" size={30} />
                </div>
                <h1 className="mb-2">You are about to submit this property to be viewed publicly</h1>
                <hr/>
                <p className="my-2">Are you sure you want to continue?</p>
                <div className="flex justify-center items-center gap-6">
                    <button className="px-8 py-1 hover:scale-105 hover:cursor-pointer transition-all bg-blue-500 rounded-10" onClick={()=>setOption(true)}>Yes</button>
                    <button className="px-8 py-1 hover:scale-105 hover:cursor-pointer transition-all border-2 border-blue-500 rounded-10" onClick={()=>setOption(false)}>No</button>

                </div>
                <p className="text-xs text-center italic py-2 w-[70%] mx-auto">Choosing no will destroy your property information you've entered thus far and redirect you to the homepage, click X if would like to review your data.</p>
            </div>
        </div>
    </div>
  )
}

export default Modal